<template>
  <div class="w-full overflow-hidden bg-white xl:flex xl:justify-end">
    <div class="p-8 bg-blue-900 rounded-l w-full">
      <product
        v-if="product"
        :selectedPrice="price"
        :selectedQty="subscription.qty"
        :min="activeAppPermissions"
        :product="product"
        @updated-qty="handleUpdateQty"
      />
      <div class="mt-4 text-white text-sm">
        <!-- eslint-disable-next-line max-len -->
        <p class="leading-tight"><strong>Note:</strong> The mininium quantity you can apply is {{ activeAppPermissions }}. The number of allocated users impacts this. To reduce your subscription further you will need to remove access from your users.</p>
        <router-link class="font-bold" to="/account/users">Go to Users</router-link>
      </div>
    </div>
    <div class="w-full bg-gray-100 p-4 rounded-r flex flex-col justify-between space-y-4">
      <header>
        <div class="text-sm text-gray-600 space-y-2">
          <!-- eslint-disable max-len -->
          <p>You will be able to use the new features immediately but won't pay anything until your next monthly invoice.</p>
          <p>On that invoice, you'll pay the new monthly fee for your upgraded subscription plus a once off adjustment fee to reflect your upgrade for the rest of this month.</p>
          <p>Click <span class="font-medium">preview</span> to see the total amount that will appear on your next invoice.</p>
          <!-- eslint-enable max-len -->
        </div>
        <div v-if="previewed">
          <ul class="mt-4 text-xs text-gray-600">
            <li
              v-for="(item,idx) in update.items"
              :key="idx"
              class="py-1"
            >
              <dl class="flex justify-between space-x-4">
                <dd class="leading-tight">{{ item.description }}</dd>
                <dt>{{ item.amount / 100 | dollar }}</dt>
              </dl>
            </li>
            <li class="py-2 border-t border-t-gray-300 font-bold">
              <dl class="flex justify-between">
                <dd>Total</dd>
                <dt>{{ update.amount / 100 | dollar }}</dt>
              </dl>
            </li>
          </ul>
        </div>
      </header>
      <div class="mt-2 flex justify-end items-end space-x-2">
        <div class="relative">
          <m-button
            v-if="previewed"
            class="w-full"
            @click="handleEdit"
          >
            Update
          </m-button>
          <m-button
            v-else
            class="w-full"
            @click="handlePreview"
          >
            Preview
          </m-button>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue-900 rounded"
            v-if="loading"
          >
            <div class="h-4 w-4">
              <m-loader class="text-white"></m-loader>
            </div>
          </div>
        </div>
        <div class="">
          <m-button
            class="w-full"
            variant="secondary"
            @click="handleCancel"
          >
            Cancel
          </m-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from '@/app/modules/account/components/subscribe/product/product.vue';
import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'account-app-edit',
  components: {
    Product,
  },
  props: {
    subscription: {
      type: Object,
    },
  },
  data() {
    return {
      newQty: null,
      loading: false,
      previewed: false,
      update: null,
    };
  },
  computed: {
    product() {
      return this.$store.getters['billing/getPriceByProduct'](this.subscription.appName);
    },
    price() {
      return this.product ? this.product.prices[0] : [];
    },
    account() {
      return this.$store.getters['account/getAccount'];
    },
    accountID() {
      return this.account.uuid;
    },
    activeAppPermissions() {
      return this.product && this.account && this.account.activePermissions
        ? this.account.activePermissions[this.product.app] || 1
        : 1;
    },
  },
  methods: {
    handleCancel() {
      this.loading = false;
      this.previewed = false;
      this.update = null;
      this.$emit('close');
    },
    handleUpdateQty(qty) {
      this.previewed = false;
      this.newQty = qty;
    },
    updateSubscription(preview = true) {
      this.loading = true;
      return API.post(`${ENDPOINTS.POST_SUBSCRIPTION}/${this.subscription.subscriptionID}`, {
        accountID: this.subscription.accountID,
        quantityModifier: this.newQty.toString(),
        previewInvoice: preview,
      })
        .catch((err) => {
          if (err) {
            this.newQty = this.subscription.qty;
          }
        });
    },
    handlePreview() {
      this.updateSubscription()
        .then((res) => {
          this.previewed = true;
          this.update = res.data.data.updatedSubscriptionResponse;
          this.loading = false;
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loading = false;
        });
    },
    handleEdit() {
      this.updateSubscription(false)
        .then(() => {
          this.$store.dispatch('billing/getSubscriptions');
          this.previewed = false;
          this.update = null;
          this.loading = false;
          this.$emit('close');
        })
        .catch(err => console.log(err));
    },
    mounted() {
      this.handleUpdateQty(this.subscription.qty);
    },
  },
};
</script>
